<template>
  <Teleport to="body">
    <div class="fixed right-4 top-4 z-[80] flex w-[min(360px,calc(100vw-32px))] flex-col gap-2">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="flex items-start gap-3 rounded-xl border bg-white px-4 py-3 text-left shadow-2xl"
          :class="toastClasses(toast.type)"
        >
          <span class="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full" :class="dotClasses(toast.type)" />
          <p class="text-sm font-semibold leading-5 text-slate-800">{{ toast.message }}</p>
          <button
            class="ml-auto text-slate-400 hover:text-slate-700"
            type="button"
            aria-label="��ng th�ng b�o"
            @click="removeToast(toast.id)"
          >
            <X :size="16" :stroke-width="2.2" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { useToast } from "@/utils/toast";
import { X } from "lucide-vue-next";

export default {
  components: { X },
  setup() {
    const { toasts, removeToast } = useToast();
    const toastClasses = (type: string) =>
      type === "success"
        ? "border-emerald-100"
        : type === "error"
        ? "border-rose-100"
        : "border-blue-100";
    const dotClasses = (type: string) =>
      type === "success"
        ? "bg-emerald-500"
        : type === "error"
        ? "bg-rose-500"
        : "bg-brand-500";
    return { toasts, removeToast, toastClasses, dotClasses };
  },
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.18s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>


